/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getApiPublicWorkflows } from '../fn/workflows/get-api-public-workflows';
import { GetApiPublicWorkflows$Params } from '../fn/workflows/get-api-public-workflows';
import { WorkflowResponse } from '../models/workflow-response';

@Injectable({ providedIn: 'root' })
export class WorkflowsService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getApiPublicWorkflows()` */
  static readonly GetApiPublicWorkflowsPath = '/api/public/{_locale}/workflows';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiPublicWorkflows()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiPublicWorkflows$Response(params: GetApiPublicWorkflows$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkflowResponse>> {
    return getApiPublicWorkflows(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiPublicWorkflows$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiPublicWorkflows(params: GetApiPublicWorkflows$Params, context?: HttpContext): Observable<WorkflowResponse> {
    return this.getApiPublicWorkflows$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkflowResponse>): WorkflowResponse => r.body)
    );
  }

}
